// src/components/MasterDataConfig.jsx
import React, { useState, useCallback } from "react";
import Button1    from "@material-ui/core/Button";
import Grid       from "@material-ui/core/Grid";
import Container  from "@material-ui/core/Container";
import { useStyles }       from "../../Styles.js";
import { MasterDataTable, TABLE_CONFIG } from "./MasterDataTable";
import { Toast }         from "../Menu/Toast";   

const TABS = [
  { key: "inquiry",  emoji: "🔍" },
  { key: "customer", emoji: "🏢" },
  { key: "campaign", emoji: "📣" },
];

export function MasterDataConfig() {
  const classes    = useStyles();
  const [activeTab, setActiveTab] = useState("inquiry");
  const [toast,     setToast]     = useState(null);

  const showToast = useCallback((msg, type = "success") => {
    setToast({ msg, type });
    setTimeout(() => setToast(null), 3500);
  }, []);

  return (
    <Container maxWidth="xl">
      <Toast toast={toast} />

      <Grid container spacing={2}>
        <Grid item xs={12}>&nbsp;</Grid>
      </Grid>

      {/* Page title */}
      <Grid container spacing={2}>
        <Grid item xs={12} sm={10}>
          <label className="head">Master Data Configuration</label>
        </Grid>
      </Grid>

      {/* Subtitle */}
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <span style={{ fontSize: 13, color: "#64748b" }}>
            จัดการข้อมูล Master สำหรับ Inquiry, Customer และ Campaign
          </span>
        </Grid>
      </Grid>

      {/* Main card */}
      <Grid container className={classes.root} style={{ marginTop: 12 }}>
        <div style={{
          width: "100%", border: "1px solid #e2e8f0", borderRadius: 8,
          overflow: "hidden", minHeight: 560, background: "#fff",
          display: "flex", flexDirection: "column",
        }}>

          {/* Tab bar */}
          <div style={{
            display: "flex", borderBottom: "1px solid #e2e8f0",
            background: "#fafafa", padding: "0 4px",
          }}>
            {TABS.map(t => {
              const cfg      = TABLE_CONFIG[t.key];
              const isActive = activeTab === t.key;
              return (
                <button
                  key={t.key}
                  onClick={() => setActiveTab(t.key)}
                  style={{
                    display:      "flex",
                    alignItems:   "center",
                    gap:          6,
                    padding:      "12px 20px",
                    fontSize:     13,
                    fontWeight:   isActive ? 700 : 400,
                    color:        isActive ? "#1d4ed8" : "#64748b",
                    background:   "none",
                    border:       "none",
                    borderBottom: isActive ? "2px solid #1d4ed8" : "2px solid transparent",
                    cursor:       "pointer",
                    transition:   "all 0.15s",
                    marginBottom: -1,
                    whiteSpace:   "nowrap",
                  }}
                >
                  <i className={`ti ${cfg.icon}`} style={{ fontSize: 15 }} />
                  {t.emoji} {cfg.label}
                </button>
              );
            })}
          </div>

          {/* Tab content — สร้างไว้ทั้ง 3 แต่ซ่อน/แสดงด้วย display */}
          {TABS.map(t => (
            <div
              key={t.key}
              style={{
                display:       activeTab === t.key ? "flex" : "none",
                flexDirection: "column",
                flex:          1,
                overflow:      "hidden",
              }}
            >
              <MasterDataTable tableKey={t.key} showToast={showToast} />
            </div>
          ))}
        </div>
      </Grid>
    </Container>
  );
}
